import { ConfigVisualisation, SUPPORTED_PITCH_VISUALISATION_KEYS } from '@/types/visualisation';

export const getVisualisationsForMetric = (allVisualisations: ConfigVisualisation[], selectedMetric: string) => {
  const universalVisualisations = allVisualisations.filter(({ universal }) => universal);
  const metricSpecificVisualisations = allVisualisations.filter(({ visualisationMetrics }) =>
    visualisationMetrics.some(({ metricKey }) => metricKey === selectedMetric),
  );
  return [...metricSpecificVisualisations, ...universalVisualisations]
    .filter(({ visualisationKey }) => SUPPORTED_PITCH_VISUALISATION_KEYS.includes(visualisationKey))
    .sort((a, b) => b.priority - a.priority);
};
